import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function RewardsIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M7.97878 2.68146C7.64256 1.77285 6.35744 1.77285 6.02122 2.68146L5.55581 3.93921C5.45011 4.22488 5.22488 4.45011 4.93921 4.55581L3.68146 5.02122C2.77285 5.35744 2.77285 6.64256 3.68146 6.97878L4.93921 7.44419C5.22488 7.54989 5.45011 7.77512 5.55581 8.06079L6.02122 9.31854C6.35744 10.2272 7.64256 10.2272 7.97878 9.31854L8.44419 8.06079C8.54989 7.77512 8.77512 7.54989 9.06079 7.44419L10.3185 6.97878C11.2272 6.64256 11.2272 5.35744 10.3185 5.02122L9.06079 4.55581C8.77512 4.45011 8.54989 4.22488 8.44419 3.93921L7.97878 2.68146Z"
        fill="currentColor"
      />
      <path
        d="M16.3352 8.27773C15.7048 6.57409 13.2952 6.57409 12.6648 8.27773L11.7921 10.636C11.5939 11.1716 11.1716 11.5939 10.636 11.7921L8.27773 12.6648C6.57409 13.2952 6.57409 15.7048 8.27773 16.3352L10.636 17.2079C11.1716 17.4061 11.5939 17.8284 11.7921 18.364L12.6648 20.7223C13.2952 22.4259 15.7048 22.4259 16.3352 20.7223L17.2079 18.364C17.4061 17.8284 17.8284 17.4061 18.364 17.2079L20.7223 16.3352C22.4259 15.7048 22.4259 13.2952 20.7223 12.6648L18.364 11.7921C17.8284 11.5939 17.4061 11.1716 17.2079 10.636L16.3352 8.27773Z"
        fill="currentColor"
      />
    </svg>
  )
}
